module.exports = __webpack_public_path__ + "img/chess-bishop-piece.d6c3fa25.svg";